import React, { useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Modal from "../../components/Modal";
import { analyticsUserTrack } from "../../config/analyticsTrack";

const ImageSlider = (props) => {
    let { images } = props;
    const settings = {
        infinite: true,
        speed: 500,
        slidesToShow: 5,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 4,
                },
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                },
            },
        ],
        arrows: true,
        dots: true,
    };

    let [active, setActive] = useState(null);

    return <div className="slider-container">
        <Slider {...settings}>
            {
                images.map((item, index) => {
                    let { file, name, position } = item
                    return <div key={index} className="parent">
                        <img className="img-fluid slide-image" src={file} style={{ objectPosition: position ? position : "50% 50%"}}/>
                        <div className="popup">
                            <span className="name">{name}</span>
                            <button className="btn btn-sm btn-secondary" onClick={() => {
                                setActive(item)
                                analyticsUserTrack("GHT", "Clicked Bio - "+name);
                            }}>Bio</button>
                        </div>
                    </div>
                })
            }
        </Slider>
        {
            active && <Modal
                visible={active ? true : false}
                closeModal={() => {
                    setActive(null)
                }}
                heading={active.name}
                body={<div className="row">
                    <div className="col-sm-3">
                        <img className="img-fluid" src={active.file}/>
                    </div>  
                    <div className="col-sm-9">
                        <div style={{ whiteSpace: "pre-wrap"}} dangerouslySetInnerHTML={{ __html: active.bio }} />
                    </div>
                </div>
                }
            />
        }
    </div>
};

export default ImageSlider;
